module.exports = __webpack_public_path__ + "img/sentencias.d6b9374a.jpg";